import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';
import { ReactSVG } from 'react-svg';
import { Button } from '@components/atoms/Button';

import dropDownImage from 'images/dropdown-arrow.svg';

export const Wrapper = styled.div`
  padding-top: 153px;
  ${media.largeScreen`
    padding-top: 50px;
  `}
  ${media.mediumScreen`
    padding-top: 70px;
  `}
  ${media.smallScreen`
    padding-top: 20px;
  `}

  div[data-cy='dropdown-select'] {
    margin-bottom: 17px;
    cursor: pointer;
    font-family: ${(props) => props.theme.typography.baseFontFamily};
    & > div {
      margin-bottom: 0;
    }
  }

  .custom-select {
    cursor: pointer;
    & > div:first-of-type {
      padding: 0;
      & > span {
        font-size: ${({ theme: { typography } }) => typography.baseFontSize};
        line-height: 100%;
      }
      & > div:first-of-type {
        margin: 0 0 0 9px;
        padding-right: 10px;
        font-size: ${({ theme: { typography } }) => typography.baseFontSize};
        line-height: 100%;
      }
      & > div:nth-of-type(2) {
        display: block;
        width: 15px;
        height: 15px;
        background-image: url(${dropDownImage});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        ${media.largeScreen`
        `}

        & > svg {
          display: none;
        }
      }
    }

    &__menu {
      box-shadow: none;
    }
    &__menu-list {
      font-size: ${({ theme: { typography } }) => typography.baseFontSize};
      line-height: 100%;
    }
    &__option {
      margin: 0;
      cursor: pointer;
      background-color: ${(props) => props.theme.colors.white};

      &:hover {
        color: ${(props) => props.theme.colors.baseFont};
        background-color: rgba(0, 0, 0, 0.1);
      }

      &--is-selected {
        font-weight: normal;
        background-color: ${(props) => props.theme.colors.red};
        &:hover {
          color: ${(props) => props.theme.colors.white};
          background-color: ${(props) => props.theme.colors.red};
        }
      }
    }
  }
`;

export const Content = styled(Container)`
  ${media.largeScreen`
    max-width: 75vw;
  `}
  ${media.mediumScreen`
    max-width: 85vw;
  `}
  ${media.smallScreen`
    width: 100%;
    max-width: initial;
    margin: 0;
    padding: 0 24px;
  `}
`;

export const Title = styled.div`
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h2FontSize};
  line-height: ${(props) => props.theme.typography.h2FontSize};
  font-style: normal;
  font-weight: normal;
  text-align: center;
  letter-spacing: -0.5px;
  color: ${(props) => props.theme.colors.baseFont};
`;

export const Icon = styled(ReactSVG)`
  margin-bottom: 9px;
  display: flex;
  justify-content: center;

  ${media.largeScreen`
    margin-bottom: -6px;
    svg {
      transform: scale(0.7);
    }
  `}
  ${media.smallScreen`
    margin-bottom: -20px;
    svg {
      transform: scale(0.5);
    }
  `}
`;

export const SliceWrapper = styled.div`
  margin: 200px 0 200px;
  ${media.largeScreen`
    margin: 100px 0 128px;
  `}
  ${media.mediumScreen`
    margin: 123px 0 132px;
  `}
  ${media.smallScreen`
    margin: 75px 0 65px;
  `}
`;

export const Filters = styled.div`
  position: relative;
  margin-bottom: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  & > img {
    position: absolute;
    right: 0;
  }

  ${media.largeScreen`
    margin-bottom: 42px;
    padding-bottom: 7px;
    align-items: flex-end;
  `}
  ${media.smallScreen`
    padding-bottom: 0px;
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const BlogsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  ${media.largeScreen`
    padding-bottom: 40px;
  `}
  ${media.smallScreen`
    padding-bottom: 20px;
  `}
`;

export const List = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 60px 40px;
  margin-top: 40px;
  ${media.largeScreen`
    grid-gap: 40px 26px;
    margin-top: 30px;
  `}
  ${media.smMediumScreen`
    grid-template-columns: 1fr 1fr;
  `}
  ${media.smallScreen`
    grid-template-columns: 1fr;
    grid-gap: 16px;
  `}
`;

export const PostTile = styled.div`
  width: 31%;
  overflow: hidden;
  margin-bottom: 60px;

  &:not(:nth-child(3n)) {
    margin-right: 2.02vw;
  }

  & > a {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
  }
  &:hover {
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);
  }
  &:hover {
    .post-card__text-side {
      background-color: #ffffff;
    }
  }

  ${media.largeScreen`
    width: 31.3%;
    margin-bottom: 38px;
  `}

  ${media.mediumScreen`
    width: 47.5%;

    &:not(:nth-child(3n)) {
      margin-right: 0;
    }

    &:not(:nth-child(2n)) {
      margin-right: 3.125vw;
    }
  `}

  ${media.smallScreen`
    margin-bottom: 30px;
    width: 100%;

    &:not(:nth-child(2n)) {
      margin-right: 0;
    }
  `}
`;

export const TagsWrapper = styled.div`
  ${media.smallScreen`
    margin-bottom: 6px;
    width: 100%;
    overflow: auto;
  `}
`;

export const TagsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  ${media.smallScreen`
    width: 200vw;
  `}

  & > li {
    margin-right: 8px;

    & > button {
      margin-bottom: 7px;
      padding: 13px 24px;
      border-radius: 30px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      transition: all 0.25s ease;

      ${media.largeScreen`
        padding: 9px 20px;
      `}

      & > span {
        font-family: ${(props) => props.theme.typography.baseFontFamily};
        font-size: ${(props) => props.theme.typography.baseFontSize};
        line-height: 100%;
        color: ${(props) => props.theme.colors.baseFont};
        font-style: normal;
        font-weight: normal;
      }

      &.active {
        background-color: ${(props) => props.theme.colors.red};
        border-color: ${(props) => props.theme.colors.red};
        transition: all 0.25s ease;
        & > span {
          color: ${(props) => props.theme.colors.white};
        }
      }
    }
  }
`;

export const BorderDiv = styled.div`
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin: 100px 0 40px;
  ${media.largeScreen`
    margin: 80px 0 30px;
  `}
  ${media.smMediumScreen`
    margin: 70px 0 30px;
  `}
  ${media.smallScreen`
    margin: 40px 0 30px;
  `}
`;

export const ShowMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const ShowMoreButton = styled(Button)`
  &.showmore {
    width: 320px;
    height: 68px;
    font-size: ${(props) => props.theme.typography.smallFontSize};
    margin: auto;
    margin-bottom: 32px;
    grid-column-start: 2;
    grid-column-end: 2;
    ${media.largeScreen`
      width: 200px;
      height: 48px;
    `}
    ${media.smMediumScreen`
      grid-column-start: 1;
      grid-column-end: none;
    `}
  }
`;
